export const DOMAIN_CONFIG = {
  hongkong: 'https://home.powerbank.mykeeta.com/',
  uk: [
    'https://keeta-charging.powerbank.mykeeta.com/',
    'https://keeta-charging.com/',
  ],
};

export function getCountryByDomain(hostname) {
  if (hostname === 'localhost') {
    return 'hongkong';
  }
  if (hostname.includes('keeta-charging')) {
    return 'uk';
  }
  return 'hongkong'; // 默认英国
}
export function getApiBaseUrl(country) {
  const env = process.env.VUE_APP_ENV;
  const hostname = window.location.hostname;

  // 从泳道域名提取泳道名: {swimlaneName}-sl-{主干域名}
  const swimlaneMatch = hostname.match(/^(.+?)-sl-/);
  const swimlaneName = swimlaneMatch ? swimlaneMatch[1] : null;

  if (country === 'hongkong') {
    if (env === 'production') {
      return 'https://enter-api-mt.powerbank.mykeeta.com/api-c';
    }
    if (swimlaneName) {
      // 泳道路由: https://{swimlaneName}-sl-test-enter-api-mt.powerbank.test.sankuai.com/api-c
      return `https://${swimlaneName}-sl-test-enter-api-mt.powerbank.test.sankuai.com/api-c`;
    }
    return 'https://test-enter-api-mt.powerbank.test.sankuai.com/api-c';
  }
  if (country === 'uk') {
    if (env === 'production') {
      return 'https://enter-api-uk.powerbank.mykeeta.com/api-c';
    }
    if (swimlaneName) {
      // 泳道路由: https://{swimlaneName}-sl-test-enter-api-uk.powerbank.test.sankuai.com/api-c
      return `https://${swimlaneName}-sl-test-enter-api-uk.powerbank.test.sankuai.com/api-c`;
    }
    return 'https://test-enter-api-uk.powerbank.mykeeta.com/api-c';
  }
}
